import { computed, makeObservable } from 'mobx';
import { List } from 'immutable';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { ModelsState } from 'src/AppState/Models/ModelsState';

export class ResponsibleGamblingTabsState {
    public constructor(
        public readonly customerId: number,
        private readonly permissionGrants: List<unknown>,
        private readonly models: ModelsState
    ) {
        makeObservable(this);
    }

    public getPermission = (permission: string): boolean => {
        if (this.permissionGrants.size > 0) {
            for (let i = 0; i < this.permissionGrants.size; i++) {
                if (this.permissionGrants.getIn([i, 'permission']) === permission) {
                    return false;
                }
            }
        }
        return true;
    };

    @computed public get currency(): CurrencyType {
        return this.models.getUserModel(this.customerId).walletData.data?.currency ?? 'XTS';
    }
}
